module.exports = __webpack_public_path__ + "CY.png?a52dad238b0bc5bf094c3ee284281c19";